import React from 'react';
import { Users, GraduationCap, Calendar, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { features } from '../../data/mock';

const iconMap = {
  Users: Users,
  GraduationCap: GraduationCap,
  Calendar: Calendar,
};

const Features = () => {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-emerald-600 font-semibold mb-4">{t('landing.features.eyebrow')}</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t('landing.features.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('landing.features.subtitle')}
          </p>
        </div>

        {/* Features grid */}
        <div className="space-y-24">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            const isReversed = index % 2 !== 0;
            const item = t(`landing.featureItems.${feature.id}`, { returnObjects: true });

            return (
              <div
                key={feature.id}
                className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-20 items-center`}
              >
                {/* Content */}
                <div className="flex-1 space-y-6">
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-50 rounded-full">
                    <Icon className="w-5 h-5 text-emerald-600" />
                    <span className="text-emerald-700 font-medium">{item.title}</span>
                  </div>

                  <h3 className="text-3xl sm:text-4xl font-bold text-gray-900">
                    {item.description}
                  </h3>

                  <ul className="space-y-3">
                    {item.highlights.map((highlight, i) => (
                      <li key={i} className="flex items-center gap-3">
                        <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                          <Check className="w-3 h-3 text-green-600" />
                        </div>
                        <span className="text-gray-600">{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Image */}
                <div className="flex-1">
                  <div className="relative rounded-2xl overflow-hidden shadow-xl">
                    <img
                      src={feature.image}
                      alt={item.title}
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
